module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/yamashiro_onsen_soyu-f9dbdd7f9ea40c38a9d68bc4e3351246.jpg";